import Box from "@/ui/atoms/Box";

const tones = {
    period: {
        background: "var(--proda-neon-blue-10)",
        color: "var(--proda-black)",
        muted: "var(--proda-black-10)",
        bold: false,
    },
    subtotal: {
        background: "var(--proda-neutral-20)",
        color: "var(--proda-white)",
        muted: "rgba(255, 255, 255, 0.75)",
        bold: true,
    },
    total: {
        background: "transparent",
        color: "var(--text-color-light)",
        muted: "rgba(255, 255, 255, 0.7)",
        bold: true,
    },
};

export type ReconciliationHeaderProps = {
    period: string;
    part: string;
    first: boolean;
    last: boolean;
    tone: keyof typeof tones;
};

export const ReconciliationHeader = ({
    period,
    part,
    first,
    last,
    tone,
}: ReconciliationHeaderProps) => {
    const style = tones[tone];
    const border = "0.5px solid var(--proda-white-150)";
    return (
        <Box
            sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "space-between",
                gap: "6px",
                padding: "4px 16px 4px 8px",
                boxSizing: "border-box",
                backgroundColor: style.background,
                color: style.color,
                fontWeight: style.bold ? 700 : 400,
                ...(tone === "total"
                    ? {}
                    : {
                          borderTop: border,
                          borderBottom: border,
                          borderLeft: first ? border : "none",
                          borderRight: last ? border : "none",
                      }),
                whiteSpace: "nowrap",
                overflow: "hidden",
            }}
        >
            <span>{first ? period : ""}</span>
            <span
                style={{
                    fontSize: 11,
                    fontWeight: 500,
                    color: style.muted,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
            >
                {part}
            </span>
        </Box>
    );
};
